import type { ObjectTreeNodeLabel } from '../types'

type DraftDetail = {
  isDraft: boolean
  type?: 'object' | 'folder'
}

export const isDraftDetailed = (objectTreeNode: ObjectTreeNodeLabel): DraftDetail => {
  const isDraft = objectTreeNode.state === 'Draft'

  const isDraftObject =
    isDraft &&
    (objectTreeNode.elementType === 'interpretation2D' ||
      objectTreeNode.elementType === 'interpretation3D' ||
      objectTreeNode.elementType === 'fault')

  const isDraftFolder =
    isDraft &&
    (objectTreeNode.elementType === 'virtualFolder' ||
      objectTreeNode.elementType === 'horizon' ||
      objectTreeNode.elementType === 'map')

  let type: DraftDetail['type']

  if (isDraftObject) {
    type = 'object'
  } else if (isDraftFolder) {
    type = 'folder'
  }

  return { isDraft, type }
}
